import React from 'react';

import css from './SectionCompanyDetails.module.css';
import classNames from 'classnames';
import { H1 } from '../../../components';
import { useIntl } from 'react-intl';

const SectionCompanyDetails = props => {
  const { className } = props;

  const intl = useIntl();

  return (
    <div className={classNames(css.root, className)}>
      <H1 className={css.h1}>
        {intl.formatMessage(
          { id: 'ContactUsPage.headingCompanyDetails' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H1>
      <p className={css.description}>
        {intl.formatMessage({ id: 'ContactUsPage.companyDetails1' })}
      </p>
      <p className={css.description}>
        {intl.formatMessage({ id: 'ContactUsPage.companyDetails2' })}
      </p>
    </div>
  );
};

export default SectionCompanyDetails;
